/** @file Breakpoint tokens matching MUI pixel values as em equivalents. */

export const breakpoints = {
  xs: '0em',
  sm: '37.5em', // 600px
  md: '56.25em', // 900px
  lg: '75em', // 1200px
  xl: '96em' // 1536px
};
